module.exports = __webpack_public_path__ + "static/media/balloons512x384.90b0b247.webp";